module.exports = __webpack_public_path__ + "img/read-the-blog.c2b6a8aa.svg";